import ApiService from '../api.services';

const SendersService = {
    list: async function (records, page, search) {
        try {
            const response = await ApiService.get(`/api/senders?records=${records}&page=${page}&search=${search}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    listByCustomer: async function (customer) {
        try {
            const response = await ApiService.get(`/api/senders/customer/${customer}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/senders/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (form) {
        console.log('ADD FORM ==> ', form);
        try {
            const response = await ApiService.post(
                '/api/senders',
                form
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form) {
        try {
            const response = await ApiService.put(
                `/api/senders/${id}`,
                form
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/senders/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default SendersService;

export { SendersService };

